<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <!-- 主表单区域 -->
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="执行时间" prop="taskRealTime">
              <j-date
                :showTime="true"
                dateFormat="YYYY-MM-DD HH:mm"
                placeholder="请选择执行时间"
                v-model="model.taskRealTime"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="执行人" prop="taskRealPerson">
              <j-dict-select-tag
                :dictCode="
                  `sys_user,realname,id,del_flag='0' and rel_tenant_ids='${this.$ls.get(
                    'TENANT_ID'
                  )}' order by realname`
                "
                pageSize="999"
                placeholder="请选择任务执行人"
                type="list"
                v-model="model.taskRealPerson"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="巡检照片" prop="patrolPicture">
              <a-upload
                :action="minioUploadAction"
                :before-upload="beforeUpload"
                :file-list="model.patrolPicture"
                :headers="tokenHeader"
                @change="handleChange"
                @preview="handlePreview"
                accept="image/*"
                listType="picture-card"
              >
                <div v-if="model.patrolPicture.length < 4">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传巡检图片</div>
                </div>
              </a-upload>
              <a-modal :footer="null" :visible="previewVisible" @cancel="handleCancel">
                <img :src="previewImage" alt="example" style="width: 100%" />
              </a-modal>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="巡检视频" prop="patrolVideo">
              <a-upload
                :action="minioUploadAction"
                :before-upload="beforeUpload1"
                :file-list="model.patrolVideo"
                :headers="tokenHeader"
                @change="handleChange1"
                @preview="videoPreview"
                accept="video/*"
                listType="picture-card"
              >
                <div v-if="model.patrolVideo.length < 4">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">上传巡检视频</div>
                </div>
              </a-upload>
              <a-modal :footer="null" :visible="videoPreviewVisible" @cancel="handleCancel1">
                <video controls="controls" height="100%" id="video" width="100%">您的浏览器不支持播放该视频！</video>
              </a-modal>
            </a-form-model-item>
          </a-col>-->

          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="mark">
              <a-textarea placeholder="请输入描述" rows="4" v-model="model.mark" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
    <j-vxe-table
      :actionButton="false"
      :columns="columns"
      :dataSource="dataSource"
      :disabled="formDisabled"
      :linkage-config="linkageConfig"
      :maxHeight="300"
      ref="taskDetailEditTable"
    >
      <template v-slot:action="props">
        <a @click="handleDelete(props)">新增</a>
      </template>
    </j-vxe-table>
  </a-spin>
</template>

<script>
  import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
  import { JEditableTableModelMixin } from '@/mixins/JEditableTableModelMixin'

  import { JVxeTableModelMixin } from '@/mixins/JVxeTableModelMixin.js'
  import { JVXETypes } from '@/components/jeecg/JVxeTable'
  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import moment from 'dayjs'
  import { initDictOptions } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'YwArtificialPatrolTaskDetailForm',
    mixins: [JeecgListMixin, JVxeTableModelMixin],
    components: {
      JEditableTableModelMixin
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 }
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 }
        },
        model: {},
        // 联动配置
        // linkageConfig: [{ requestData: this.getResultOptions, key: 'patrolType' }],
        linkageConfig: [{ requestData: this.getResultOptions, key: 'patrolType' }],

        dataSource: [],
        columns: [
          // {
          //   title: '供水流域',
          //   key: 'processName',
          //   type: FormTypes.textarea,
          //   width: '150px',
          //   placeholder: '请输入${title}',
          //   defaultValue: '',
          //   disabled: true,
          //   validateRules: [{ required: true, message: '${title}不能为空' }]
          // },
          {
            title: '巡检点',
            key: 'pointName',
            type: FormTypes.textarea,
            width: '150px',
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true,
            validateRules: [{ required: true, message: '${title}不能为空' }]
          },
          {
            title: '巡检设备',
            key: 'devName',
            type: FormTypes.textarea,
            width: '200px',
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true,
            validateRules: [{ required: true, message: '${title}不能为空' }]
          },
          {
            // title: '巡检类型',
            // key: 'patrolType',
            // type: JVXETypes.select,

            // width: '160px',
            // placeholder: '请输入${title}',
            // defaultValue: '',
            // linkageKey: 'patrolResult',
            // validateRules: [{ required: true, message: '${title}不能为空' }]
            title: '巡检类型',
            key: 'patrolType',
            type: JVXETypes.select,
            width: '180px',
            defaultValue: '',
            placeholder: '请选择${title}',
            // 联动字段（即下一级的字段）
            linkageKey: 'patrolResult',
            validateRules: [{ required: true, message: '${title}不能为空' }]
          },
          {
            title: '巡检项',
            key: 'patrolItem',
            type: FormTypes.textarea,
            width: '120px',
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true,
            validateRules: [{ required: true, message: '${title}不能为空' }]
          },
          {
            title: '巡检内容',
            key: 'patrolContent',
            type: FormTypes.textarea,
            width: '400px',
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: true,
            validateRules: [{ required: true, message: '${title}不能为空' }]
          },
          {
            title: '巡检结果',
            key: 'patrolResult',
            type: JVXETypes.select,
            width: '160px',
            placeholder: '请输入${title}',
            defaultValue: '',
            disabled: false,
            validateRules: [{ required: true, message: '${title}不能为空' }]
          }
        ],
        confirmLoading: false,
        validatorRules: {
          taskRealTime: [{ required: true, message: '请输入执行时间!' }],
          taskRealPerson: [{ required: true, message: '请输入执行人!' }],
          patrolResult: [{ required: true, message: '请输入巡检结果!' }]
        },
        url: {
          editTask: '/device/patrol/ywArtificialPatrolTask/edit',
          detailList: '/device/patrol/ywArtificialPatrolTaskDetail/list',
          getCategoryList: '/custom/category/childListByPCode'
        },
        previewVisible: false,
        previewImage: '',
        videoPreviewVisible: false,
        previewVideo: '',
        cacheTypeDictList: []
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
      minioUploadAction () {
        return window._CONFIG['domianURL'] + this.url.minioUpload
      }
    },
    created () { },
    methods: {
      show (record) {
        if (!record.taskRealTime) {
          this.model = Object.assign(
            {
              taskRealTime: moment().format('YYYY-MM-DD HH:mm'),
              taskRealPerson: this.$store.getters.userInfo.id,
              patrolPicture: [],
              patrolVideo: []
            },
            record
          )
        } else {
          this.model = Object.assign({}, record)
        }
        this.visible = true
        this.loadDetailData()
      },
      loadDetailData () {
        getAction(this.url.detailList, {
          taskId: this.model.id,
          column: 'orderNo'
        }).then(res => {
          if (res.success) {
            this.dataSource = res.result.records
          }
        })
      },
      loadData () { },
      submitForm (taskStatus) {
        const that = this
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true
            let httpurl = that.url.editTask
            let method = 'put'

            // 整理成formData
            let formData = Object.assign(that.model, {
              taskStatus: taskStatus,
              taskDetailList: that.dataSource
            })

            httpAction(httpurl, formData, method)
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.$emit('ok')
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.confirmLoading = false
              })
          }
        })
      },
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      handleChange (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`)
          } else {
            this.$message.error(`${info.file.response.message}`)
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`)
        }
        if (validatenotnull(info.fileList)) {
          this.model.defPicture = info.fileList.map(item => {
            let url = validatenotnull(item.url)
              ? item.url
              : validatenotnull(item.response) && validatenotnull(item.response.message)
                ? item.response.message
                : ''
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
        }
      },
      beforeUpload (file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isJpgOrPng) {
          this.$message.error('仅支持 JPG/PNG 格式图片文件!')
        }
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error('图片不能大于 10MB!')
        }
        return isJpgOrPng && isLt10M
      },
      handleCancel1 () {
        this.videoPreviewVisible = false
      },
      handleChange1 (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`)
          } else {
            this.$message.error(`${info.file.response.message}`)
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`)
        }
        if (validatenotnull(info.fileList)) {
          this.model.defVideo = info.fileList.map(item => {
            let url = validatenotnull(item.url)
              ? item.url
              : validatenotnull(item.response) && validatenotnull(item.response.message)
                ? item.response.message
                : ''
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: url
            }
          })
        }
      },
      beforeUpload1 (file) {
        const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/webm'
        if (!isVideo) {
          this.$message.error('仅支持视频文件!')
        }
        const isLt50M = file.size / 1024 / 1024 < 50
        if (!isLt50M) {
          this.$message.error('视频不能大于 50MB!')
        }
        return isVideo && isLt50M
      },
      videoPreview (file) {
        //预览视频的方法
        this.videoPreviewVisible = true
        this.$nextTick(() => {
          //这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
          const video = document.getElementById('video')
          video.src = file.url
        })
      },
      getResultOptions (parent) {
        console.info(parent, '==========parent===')

        // 如果parent为空，则查询第一级菜单
        // if (parent === '') {
        return new Promise((resolve, reject) => {
          if (parent == '') {
            initDictOptions('patrol_item_type').then(res => {
              if (res.success) {
                console.info(res.result, '==========parent===')

                resolve(res.result)
              }
            })
          } else if (parent === 'exception-check') {
            const re = [
              { value: '1', text: '正常' },
              { value: '2', text: '异常' }
            ]
            console.info(re, '==========exception-check===')

            resolve(re)
          } else {
            getAction(this.url.getCategoryList, {
              pCode: 'A13A01'
            }).then(res => {
              if (res.success) {
                const result = res.result.map(item => {
                  return { value: item.cusProp1, text: item.name }
                })
                console.info(result, '==========-check===')

                resolve(result)
              }
            })
          }
        })

        // }
        // return res
      },
      loadTypeData (parent) {
        const d = [
          {
            id: 11,
            name: 'test1'
          },
          {
            id: 22,
            name: 'test2'
          }
        ]
        return new Promise((resolve, reject) => {
          const itemData = d.find(item => item.id === parent)

          resolve(itemData)
        })
      },
      loadDictOptions (parent) {
        console.info(parent, 'pp============')

        return new Promise((resolve, reject) => {
          let data = this.mockData.filter(i => i.parent === parent)
          setTimeout(() => {
            resolve(data)
          }, 500)
        })
      }
    }
  }
</script>
